// extracted by mini-css-extract-plugin
export default {"headline":"bDvu","subheadline":"efDP","button":"z1g2","error-page":"zDWC"};